import { LEAVE_ROLE } from '@/utils/constUtils'
import { facedoorH5Url } from '@/env'
import { getCorpId } from '@/utils/comUtils'
const corpId = getCorpId() || ''

export const educationalMenusHe = [
  {
    id: 30,
    name: '班级放学',
    icon: '&#xe6e6;',
    module: '30',
    path: '/afterschool/index',
    access: [LEAVE_ROLE.admin, LEAVE_ROLE.headmaster]
  },
  {
    id: 31,
    name: '学生留堂',
    title: 'detention',
    path: '/afterschool/detention/index',
    icon: '&#xe6e7;',
    module: '31',
    access: [LEAVE_ROLE.admin, LEAVE_ROLE.headmaster, LEAVE_ROLE.teacher]
  },
  {
    id: 6,
    name: '滞留生托管',
    path: '/flexleave/index',
    icon: '&#xe672;',
    module: '8',
    access: [LEAVE_ROLE.admin, LEAVE_ROLE.headmaster, LEAVE_ROLE.teacher]
  },
  {
    id: 1,
    name: '学生考勤',
    path: '/attendance/index',
    icon: '&#xe675;',
    module: '1',
    access: [
      LEAVE_ROLE.admin,
      LEAVE_ROLE.headmaster,
      LEAVE_ROLE.guardian,
      LEAVE_ROLE.customRole
    ]
  },
  {
    id: 2,
    name: '学生请假',
    path: '/leave/index',
    icon: '&#xe677;',
    module: '2',
    access: [
      LEAVE_ROLE.admin,
      LEAVE_ROLE.headmaster,
      LEAVE_ROLE.guardian,
      LEAVE_ROLE.customRole
    ]
  },
  {
    id: 7,
    name: '数据大屏',
    path: '/screen/index',
    icon: '&#xe678;',
    module: '7',
    access: [LEAVE_ROLE.admin, LEAVE_ROLE.customRole]
  },
  {
    id: 28,
    name: '学期时间',
    title: 'schoolCalendar',
    path: '/schoolCalendar',
    icon: '&#xe775;',
    module: '28',
    access: [LEAVE_ROLE.admin]
  }
]

export const devicesMenusHe = [
  {
    id: 6,
    module: '6',
    name: '门禁管理',
    path: `${facedoorH5Url}?corpId=${corpId}&type=shortcut`,
    icon: '&#xe676;',
    access: [LEAVE_ROLE.admin]
  }
]
export const mainMenusHe = []
export const otherMenusHe = []
export const leaveSchoolMenusHe = []
export const securityMenusHe = []
export const basicMenusHe = []
export const serveMenusHe = []
export const evaluationMenusHe = []
